module.exports = __webpack_public_path__ + "img/xtermo.b15d9851.png";